import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCT_TEMPLATES_API,
} from '../../../constants/API';
import {
  CREATE_PRODUCT_TEMPLATE_LOADING
} from '../types';
import getProductTemplates from './getProductTemplates';

function createLocation(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_PRODUCT_TEMPLATE_LOADING,
        creatingProductTemplate: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const hide = message.loading('Creating Product Template', 0);
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        await axios.post(PRODUCT_TEMPLATES_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        hide()
        dispatch({
          type: CREATE_PRODUCT_TEMPLATE_LOADING,
          creatingProductTemplate: false
        });
        await dispatch(getProductTemplates());
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_PRODUCT_TEMPLATE_LOADING,
          creatingProductTemplate: false
        });
        console.log(e);
      }
  }
}
export default createLocation;
